<template>
  <!--
    	作者：wangxw
    	时间：2019-11-05
    	描述：diy组件 视频
    -->
  <div>
    <div class="common-form">
      <span>{{ curItem.name }}</span>
    </div>
    <el-form size="small" :model="curItem" label-width="100px">
      <!--上下边距-->
      <el-form-item label="上下边距：">
        <el-slider v-model.number="curItem.style.paddingTop" style="width: 50%" show-input></el-slider>
      </el-form-item>
      <!--视频高度-->
      <el-form-item label="视频高度：">
        <el-slider v-model.number="curItem.style.height" style="width: 50%" :min="50" :max="500" show-input></el-slider>
        <div>
          滑块可用左右方向键精确调整
        </div>
      </el-form-item>
      <!--视频封面-->
      <el-form-item label="视频封面：">
        <div class="diy-video-cover">
          <img v-img-url="curItem.params.poster" alt="" @click="$parent.onEditorSelectImage(curItem.params, 'poster')">
        </div>
      </el-form-item>
      <!--视频地址-->
      <el-form-item label="视频地址：">
        <div>
          <el-button type="primary" @click="onVideoChoose">添加视频</el-button>
          <el-button type="danger" v-if="curItem.params.videoUrl" @click="delVideo">删除视频
          </el-button>
        </div>
        <el-input class="m-t-20" v-model="curItem.params.videoUrl" style="width: 50%"></el-input>
      </el-form-item>
      <!--自动播放-->
      <el-form-item label="自动播放：">
        <el-radio-group v-model="curItem.params.autoplay">
          <el-radio :label="0">否</el-radio>
          <el-radio :label="1">是</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <Upload v-if="isProductUpload" :config="config" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">
      上传图片
    </Upload>
  </div>
</template>

<script>
import Upload from '@/components/file/Upload'

export default {
  components: {
    Upload
  },
  data () {
    return {
      paddingTop: 0,
      height: 0,
      isProductUpload: false,
      config: {
        total: 1,
        fileType: 'video'
      },
    }
  },
  props: ['curItem', 'selectedIndex'],
  created () {
    this.curItem.style.paddingTop = parseInt(this.curItem.style.paddingTop)
    this.curItem.style.height = parseInt(this.curItem.style.height)
  },
  watch: {},
  methods: {
    onVideoChoose () {
      this.isProductUpload = true
    },
    delVideo () {
      this.curItem.params.videoUrl = ''
    },
    returnProductImgsFunc (e) {
      if (e != null) {
        this.curItem.params.videoUrl = e[0].filePath
      }
      this.isProductUpload = false
    }
  }
}
</script>

<style>
.diy-video-cover {
  width: 200px;
}

.diy-video-cover img {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/page/page/diy/params/Video.vue